<template>
  <b-container>
    <b-row>
      <div style="margin:20px 0">
        <el-steps :active="step" align-center>
          <el-step style="cursor:pointer" @click.native="step = 1" title="Genel" description="Firma Bilgileri"></el-step>
          <el-step style="cursor:pointer" title="Ayarlar" description="Firma Ayarları"></el-step>
        </el-steps>
      </div>
    </b-row>
    <b-row>
      <b-card-group v-if="step == 1" deck>
        <b-card header="Firma Ekle" header-tag="header">
            <b-row>
              <b-col cols="2">
                  <b-form-group label="Firma Adı">
                    <b-form-input size="sm" v-model="form.general.title" placeholder="Firma Adı"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group label="Host bilgisi (Güvenlik için)">
                    <b-form-input size="sm" v-model="form.general.host" placeholder="tahsilat.e-tahsilat.io"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group label="Çalışan Site Adresi">
                    <b-form-input size="sm" v-model="form.general.domain" placeholder="https://tahsilat.e-tahsilat.io"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group label="Firma Site Adresi">
                    <b-form-input size="sm" v-model="form.general.client_url" placeholder="Firma Site Adresi"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group label="Firma Sitesinin İletişim Sayfası">
                    <b-form-input size="sm" v-model="form.general.contact_url" placeholder="Firma Sitesinin İletişim Sayfası"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group label="Durum">
                    <b-form-select size="sm" v-model="form.general.status" class="form-control mb-3 form-control-sm"  placeholder="Ödeme Notunuz">
                      <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                      <b-form-select-option :value="1">Aktif</b-form-select-option>
                      <b-form-select-option :value="0">Pasif</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group style="margin-top:29px">
                    <b-button @click="toStep(2)" variant="primary" size="sm">Devam Et</b-button>
                  </b-form-group>
              </b-col>
            </b-row>
        </b-card>
      </b-card-group>
      <b-card-group v-if="step == 2" deck>
        <b-card header="Firma Ekle : Ayarlar" header-tag="header">
            <b-row>
              <b-col cols="4">
                <b-form-group label="Logo">
                  <label class="file-input"> 
                    <slot v-if="_.isNull(form.settings.logo)">
                      Dosyanızı Seçiniz
                    </slot>
                    <slot v-else>
                      <div class="text-success">Dosyanız Seçildi </div>
                    </slot>
                    <input @change="file($event)" type="file" size="60" >
                  </label>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="Varsayılan Banka">
                    <b-form-select size="sm" v-model="form.settings.default_payment_id" class="form-control mb-3 form-control-sm"  placeholder="Ödeme Notunuz">
                      <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                      <b-form-select-option :value="item.id" v-for="(item,key) in payments" :key="key">{{ item.name }}</b-form-select-option>
                    </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="5">
                <b-form-group label="İletişim">
                  <b-form-input size="sm" v-model="form.settings.contact" placeholder="İletişim"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Footer Metni">
                  <b-form-input size="sm" v-model="form.settings.footer_text" placeholder="Footer Metni"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Telefon">
                    <b-form-input size="sm" v-model="form.settings.phone" placeholder="Telefon"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Fax Numarası">
                    <b-form-input size="sm" v-model="form.settings.fax_number" placeholder="Fax Numarası"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="6">
                  <b-form-group label="Kep Maili">
                    <b-form-input type="email" size="sm" v-model="form.settings.kep_mail" placeholder="Keep Maili"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="6">
                  <b-form-group label="Destek Maili">
                    <b-form-input type="email" size="sm" v-model="form.settings.support_mail" placeholder="Destek Maili"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group style="margin-top:29px">
                    <b-button :disabled="loading" @click="send()" style="width:100%" variant="primary" size="sm">Ekle</b-button>
                  </b-form-group>
              </b-col>
            </b-row>
        </b-card>
      </b-card-group>
    </b-row>
  </b-container>
</template>

<script>
  export default{
    name: 'CompaniesCreate',
    data(){
      return{
        step: 1,
        loading: false,
        payments:[],
        form:{
          general:{
            title:null,
            domain: null,
            client_url: null,
            contact_url: null,
            status: null
          },
          settings:{
            default_payment_id: null,
            logo: null,
            logo_src: null,
            contact: null,
            footer_text:null,
            phone: null,
            fax_number: null,
            kep_mail: null,
            support_mail: null,
          },
        }
      }
    },
    created(){
      this.fetchPayments();
    },
    methods:{
      send(){
        const config = { headers: { 'Content-Type': 'multipart/form-data' } };
        let data = new FormData();
        for ( var key in this.form.general ) {data.append(key, this.form.general[key]);}
        for ( var key in this.form.settings ) {data.append(key, this.form.settings[key]);}
        this.loading = true;
        axios.post('/client/create', data, config)
        .then((response) => {
            this.$store.dispatch('alert/message', { type: 'warning', title: 'Ekleme Başarılı'});
            this.$router.push({name: 'Companies'});
        })
        .catch((err) => {
        })
        .finally(()=>{
            this.loading = false;
        })
      },
      fetchPayments(){
        axios.get('/list/payments')
        .then((response) => {
            this.payments = response.data.data;
        })
        .catch((err) => {
        })
        .finally(()=>{
        });
      },
      file(event){
        const file = event.target.files[0];
        this.form.settings.logo = file;
        this.form.settings.logo_src = URL.createObjectURL(file);
      },
      toStep(step){
        if(step == 2){
          if(_.findKey(this.form.general, _.isNull)){
            this.$store.dispatch('alert/message', { type: 'warning', title: 'Lütfen gerekli kutucukları doldurunuz'});
            return false;
          }else{
            this.step = 2;
          }
        }
      }
    }
  }
</script>